import React from "react";
import Head from "next/head";
import { useSelector } from "react-redux";
import { selectData } from "../../redux/dataSlice";
import { SeoTypes } from "./Seo.types";

const Seo = (props) => {
  const data = useSelector(selectData);
  const { title } = props;
  
  let key: any;
  if (data) {
    key = Object.keys(data);
  }
  const seoData: SeoTypes = data?.[key]?.metadata?.results?.[0];

  return (
    <div data-testid="seo-container-id">
      <Head>
        <title>{title ?? seoData?.title}</title>
        <meta property="og:title" content={title ?? seoData?.title} key="title" />
        <meta name="description" content={seoData?.description} />
        <meta name="keywords" content={seoData?.keywords} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
    </div>
  );
};

export default Seo;
